// SocialCheck – Signup / Zugang beantragen + Einladung aktivieren (DE/FR/IT/EN)
export const signupTranslations = {
  de: {
    tagline: "Zugang zum SocialCheck Growth OS",
    heroLine1: "Social Media klar freigeben.",
    heroLine2: "Ohne E-Mail-Chaos.",
    heroBody: "KEWAG erstellt Inhalte. Sie prüfen Beiträge, Bilder und Texte in einer klaren App.",
    heroSub: "Für Schweizer KMU, Teams und lokale Betriebe.",
    heroFeatures: [
      { title: "Ampel-Freigabe", sub: "Klar prüfen & freigeben" },
      { title: "Social-Kalender", sub: "Alles im Überblick" },
      { title: "Monatsbericht", sub: "Klare Auswertungen" },
    ],
    verifiedBy: "Persönlich geprüft durch",
    tabRequest: "Zugang anfragen",
    tabActivate: "Einladung aktivieren",
    requestTitle: "Zugang / Demo beantragen",
    requestSub: "Kein offenes Konto — Ihre Anfrage geht direkt an das KEWAG-Team. Wir melden uns und richten Ihren Zugang ein.",
    name: "Name", email: "E-Mail", company: "Firma", phone: "Telefon (optional)",
    message: "Ihre Nachricht (optional)",
    requestBtn: "Anfrage senden", requestSending: "Wird gesendet…",
    emailPlaceholder: "name@firma.ch",
    captchaFailed: "Die Sicherheitsprüfung konnte nicht bestätigt werden. Bitte erneut versuchen.",
    rateLimited: "Zu viele Anfragen in kurzer Zeit. Bitte später erneut versuchen.",
    requestDoneTitle: "Anfrage erhalten",
    requestDone: "Danke! Ihre Anfrage ist beim KEWAG-Team eingegangen. Wir melden uns in Kürze bei Ihnen.",
    activateTitle: "Einladung aktivieren",
    activateSub: "Sie haben eine Einladung von KEWAG erhalten. Legen Sie jetzt Ihr Passwort fest.",
    inviteFor: "Einladung für",
    password: "Passwort (mind. 8 Zeichen)", passwordConfirm: "Passwort bestätigen",
    activateBtn: "Konto aktivieren", activating: "Wird aktiviert…",
    haveInvite: "Haben Sie einen Einladungslink? Geben Sie den Code ein:",
    inviteCode: "Einladungs-Code",
    checkInvite: "Prüfen",
    backToLogin: "Zurück zum Login",
    mismatch: "Die Passwörter stimmen nicht überein.",
    inviteInvalid: "Einladung ungültig oder bereits verwendet.",
    error: "Es ist ein Fehler aufgetreten. Bitte erneut versuchen.",
  },
  fr: {
    tagline: "Accès au SocialCheck Growth OS",
    heroLine1: "Validez vos réseaux sociaux en toute clarté.",
    heroLine2: "Sans le chaos des e-mails.",
    heroBody: "KEWAG crée les contenus. Vous validez publications, images et textes dans une app claire.",
    heroSub: "Pour les PME, équipes et entreprises locales suisses.",
    heroFeatures: [
      { title: "Validation feu", sub: "Vérifier & valider en clair" },
      { title: "Calendrier social", sub: "Tout en un coup d’œil" },
      { title: "Rapport mensuel", sub: "Analyses claires" },
    ],
    verifiedBy: "Vérifié personnellement par",
    tabRequest: "Demander l’accès",
    tabActivate: "Activer l’invitation",
    requestTitle: "Demander un accès / une démo",
    requestSub: "Pas de compte ouvert — votre demande est envoyée directement à l’équipe KEWAG. Nous vous recontactons et configurons votre accès.",
    name: "Nom", email: "E-mail", company: "Entreprise", phone: "Téléphone (facultatif)",
    message: "Votre message (facultatif)",
    requestBtn: "Envoyer la demande", requestSending: "Envoi…",
    emailPlaceholder: "nom@entreprise.ch",
    captchaFailed: "La vérification de sécurité n’a pas pu être confirmée. Veuillez réessayer.",
    rateLimited: "Trop de demandes en peu de temps. Veuillez réessayer plus tard.",
    requestDoneTitle: "Demande reçue",
    requestDone: "Merci ! Votre demande est parvenue à l’équipe KEWAG. Nous vous recontactons rapidement.",
    activateTitle: "Activer l’invitation",
    activateSub: "Vous avez reçu une invitation de KEWAG. Définissez votre mot de passe.",
    inviteFor: "Invitation pour",
    password: "Mot de passe (min. 8 caractères)", passwordConfirm: "Confirmer le mot de passe",
    activateBtn: "Activer le compte", activating: "Activation…",
    haveInvite: "Vous avez un lien d’invitation ? Saisissez le code :",
    inviteCode: "Code d’invitation",
    checkInvite: "Vérifier",
    backToLogin: "Retour à la connexion",
    mismatch: "Les mots de passe ne correspondent pas.",
    inviteInvalid: "Invitation invalide ou déjà utilisée.",
    error: "Une erreur s’est produite. Veuillez réessayer.",
  },
  it: {
    tagline: "Accesso a SocialCheck Growth OS",
    heroLine1: "Approva i social media con chiarezza.",
    heroLine2: "Senza il caos delle e-mail.",
    heroBody: "KEWAG crea i contenuti. Tu approvi post, immagini e testi in un’app chiara.",
    heroSub: "Per PMI, team e attività locali svizzere.",
    heroFeatures: [
      { title: "Approvazione semaforo", sub: "Controlla e approva" },
      { title: "Calendario social", sub: "Tutto sott’occhio" },
      { title: "Report mensile", sub: "Analisi chiare" },
    ],
    verifiedBy: "Verificato personalmente da",
    tabRequest: "Richiedi accesso",
    tabActivate: "Attiva invito",
    requestTitle: "Richiedi accesso / demo",
    requestSub: "Nessun account aperto — la tua richiesta va direttamente al team KEWAG. Ti ricontattiamo e configuriamo il tuo accesso.",
    name: "Nome", email: "E-mail", company: "Azienda", phone: "Telefono (facoltativo)",
    message: "Il tuo messaggio (facoltativo)",
    requestBtn: "Invia richiesta", requestSending: "Invio…",
    emailPlaceholder: "nome@azienda.ch",
    captchaFailed: "Non è stato possibile confermare il controllo di sicurezza. Riprova.",
    rateLimited: "Troppe richieste in poco tempo. Riprova più tardi.",
    requestDoneTitle: "Richiesta ricevuta",
    requestDone: "Grazie! La tua richiesta è arrivata al team KEWAG. Ti ricontattiamo a breve.",
    activateTitle: "Attiva invito",
    activateSub: "Hai ricevuto un invito da KEWAG. Imposta ora la tua password.",
    inviteFor: "Invito per",
    password: "Password (min. 8 caratteri)", passwordConfirm: "Conferma password",
    activateBtn: "Attiva account", activating: "Attivazione…",
    haveInvite: "Hai un link di invito? Inserisci il codice:",
    inviteCode: "Codice invito",
    checkInvite: "Verifica",
    backToLogin: "Torna al login",
    mismatch: "Le password non coincidono.",
    inviteInvalid: "Invito non valido o già utilizzato.",
    error: "Si è verificato un errore. Riprova.",
  },
  en: {
    tagline: "Access to the SocialCheck Growth OS",
    heroLine1: "Approve social media clearly.",
    heroLine2: "Without the email chaos.",
    heroBody: "KEWAG creates the content. You approve posts, images and texts in one clear app.",
    heroSub: "For Swiss SMEs, teams and local businesses.",
    heroFeatures: [
      { title: "Traffic-light approval", sub: "Check & approve clearly" },
      { title: "Social calendar", sub: "Everything at a glance" },
      { title: "Monthly report", sub: "Clear analytics" },
    ],
    verifiedBy: "Personally checked by",
    tabRequest: "Request access",
    tabActivate: "Activate invitation",
    requestTitle: "Request access / demo",
    requestSub: "No open account — your request goes straight to the KEWAG team. We’ll get back to you and set up your access.",
    name: "Name", email: "Email", company: "Company", phone: "Phone (optional)",
    message: "Your message (optional)",
    requestBtn: "Send request", requestSending: "Sending…",
    emailPlaceholder: "name@company.ch",
    captchaFailed: "The security check could not be confirmed. Please try again.",
    rateLimited: "Too many requests in a short time. Please try again later.",
    requestDoneTitle: "Request received",
    requestDone: "Thank you! Your request reached the KEWAG team. We’ll be in touch shortly.",
    activateTitle: "Activate invitation",
    activateSub: "You received an invitation from KEWAG. Set your password now.",
    inviteFor: "Invitation for",
    password: "Password (min. 8 characters)", passwordConfirm: "Confirm password",
    activateBtn: "Activate account", activating: "Activating…",
    haveInvite: "Have an invitation link? Enter the code:",
    inviteCode: "Invitation code",
    checkInvite: "Check",
    backToLogin: "Back to login",
    mismatch: "The passwords do not match.",
    inviteInvalid: "Invitation invalid or already used.",
    error: "An error occurred. Please try again.",
  },
};
